import { createContext, useContext } from 'react';

/**
 * Kontext und Hook des Ansagers - bewusst in einer eigenen Datei.
 *
 * `Ansager.tsx` enthaelt eine Komponente; die Lint-Regel `react-refresh`
 * verlangt, dass eine solche Datei **nur** Komponenten ausgibt. Kontext und
 * Hook stehen deshalb hier.
 *
 * Warum es den Ansager ueberhaupt gibt, steht in `Ansager.tsx`.
 */

export type Ansagen = (text: string, dringend: boolean) => void;

export const AnsagerKontext = createContext<Ansagen | null>(null);

/**
 * Gibt die Ansagefunktion zurueck - oder `null`, wenn kein Ansager im Baum
 * haengt. `Meldung` faellt dann auf einen eigenen `aria-live`-Bereich zurueck,
 * damit ein Baustein ausserhalb der Anwendung nicht voellig stumm bleibt.
 */
export const useAnsager = (): Ansagen | null => useContext(AnsagerKontext);
